import { render, staticRenderFns } from "./ImparBlock.vue?vue&type=template&id=0ea62d90&scoped=true"
import script from "./ImparBlock.vue?vue&type=script&lang=js"
export * from "./ImparBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea62d90",
  null
  
)

export default component.exports